import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getPatientViruses, getPatientDependentsViruses, setCurrentPatients } from '../../app/actions/appActions';
import User from '../../components/User';
import Input from '../../components/Input';
import Title from '../../components/Title';
import PatientVirus from './Virus';

import './styles.scss';


const Patient = ({user, patient,patientViruses, dependentsViruses, currentPatients}) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const [state, setState] = useState({
		firstName: '',
		lastName: '',
		textarea: '',
		email: '',
		date: '',
		phone: '',
		userId: '',
		startDate : ''
	});

	const handleChangeInput = (target) => {
		setState( (state)=> ({...state,[target.id]:target.value}))
	};

	const handleSubmit = (event) => {
		event.preventDefault();
	};

	const handleLinkClick = (userId, virusID) => {
		history.push(`/patient/${userId}/virus/${virusID}`);
	};

	const initDataPatient = (patient) => {
		setState((state)=> ({
			...state,
			firstName: patient.firstName,
			lastName: patient.lastName,
			email: patient.email,
			birthDate: patient.birthDate,
			phone: patient.phone,
			userId: patient.userId,
		}));
	};

	useEffect(() => {
		if(!patient) {
			history.push(`/`);
		} else {
			initDataPatient(patient);
			dispatch(getPatientViruses(patient.userId));
			dispatch(getPatientDependentsViruses(patient.dependent))
			currentPatients && dispatch(setCurrentPatients(currentPatients))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);

	return (
		<div className="container">
			<div className="patient">
				<div className="patient__user">
					{
						patient && <User user={patient} isEdit isBig/>
					}
				</div>

				<form onSubmit={handleSubmit}>
					<div className="patient__row">
						<div className="patient__col patient__col--margin-right">
							<Input 
								value={state.firstName}
								id='firstName'
								type='text' 
								label='first Name' 
								onChange={handleChangeInput}
							/>
						</div>
						<div className="patient__col">
							<Input 
								value={state.lastName}
								id='lastName'
								type='text' 
								label='last Name' 
								onChange={handleChangeInput}
							/>
						</div>
					</div>
					<div className="patient__row">
						<div className="patient__col patient__col--margin-right">
							<Input 
								value={state.email}
								id='email'
								type='email' 
								label='email' 
								onChange={handleChangeInput}
							/>
						</div>
						<div className="patient__row patient__col">
							<div className="patient__col patient__col--margin-right">
								<Input 
									value={state.birthDate}
									id='birthDate'
									type='date' 
									label='DOB'
									onChange={handleChangeInput}
								/>
							</div>
							<div className="patient__col">
								<Input 
									value={state.phone}
									id='phone'
									type='tel' 
									label='phone' 
									onChange={handleChangeInput}
									required
								/>
							</div>
						</div>
					</div>	
				</form>
			
				<div className="patient__virus-list">
					<div className="patient__virus-title">
						<Title text={`${patient.firstName} Virus Listing`} isTexStart/>
					</div>
					{
						patientViruses.length ? 
							<div>
								{
									Object.values(patientViruses[0].dependentDocuments).map((document,i) => {
										return (
											<div onClick={() => handleLinkClick(patient.userId, document.virusId)} key={document.virusId + i}>
												<PatientVirus documentsForVirus={document}/>
											</div>
										)
									})
								}
							</div>
							: 
							<div className="patient__virus-not-doc">
								<Title text={`${patient.firstName} has no documents`} isTexStart/>
							</div>
					}
				</div>
				{
					dependentsViruses.length ? (
						dependentsViruses.map((dependent,i) => {
							return (
								<div 
									className="patient__virus-list"
									key={dependent.patientFullName + i}
								>
									<div className="patient__virus-title">
										<Title text={`${dependent.patientFullName} Virus Listing`} isTexStart/>
									</div>
									<div>
										{
											Object.keys(dependent.dependentDocuments).length ? 
												Object.values(dependent.dependentDocuments).map(document => {
													return (
														<div onClick={() => handleLinkClick(document.patientId, document.virusId)} key={document.virusId}>
															<PatientVirus documentsForVirus={document}/>
														</div>
													)
												})
												: 
											<div className="patient__virus-not-doc">
												<Title text={`${patient.firstName} has no documents`} isTexStart/>
											</div>
										}
									</div>
								</div>
							)
						})
					)
					:
					undefined
				}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const userId = ownProps.match.params.id;
	let patient = state.app.algoliaData.patients.filter((patient) => patient.userId === userId);
	if(!patient.length) {
		patient = state.app.dataPatients.filter((patient) => patient.userId === userId);
	};

	const patientViruses =  state.app.patientViruses;
	const dependentsViruses =  state.app.dependentsViruses;

	let currentPatients = {}

	if(patient[0]) {
		currentPatients[patient[0].userId] = patient[0];
		currentPatients = {...currentPatients, ...patient[0].dependent}
	}

	return {
		patient: patient[0],
		patientViruses, 
		dependentsViruses,
		currentPatients
	};
};

export default connect(mapStateToProps)(Patient);
